import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button.js';

export const Header = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  return (
    <>
      <div className="w-full flex items-center px-[15px] justify-between border rounded-[10px] border-gray-200 py-[15px]">
        <span>LOGO</span>
        <Button
          onClick={() => navigate('/auth')}
          className="px-[25px] py-[10px] rounded-[4px] bg-blue-950 text-white font-[500]"
        >
          {t('common:cabinet')}
        </Button>
      </div>
    </>
  );
};
